import React from 'react';
import { DatoCmsInformationSectionRichText } from '../../../schema/datocms/blocks';
import HtmlStringComponent from '../../html-string/html-string-component';

const InformationSectionRichTextComponent = ({ mainTextHtml }: DatoCmsInformationSectionRichText): React.ReactElement => {
    return (
        <HtmlStringComponent htmlString={mainTextHtml} />
    );
};

export default InformationSectionRichTextComponent;